var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAssignIndividuallyLepAtm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#CEDFF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#F5FAFF",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3307 30.5V28.8333C31.3307 27.2801 30.2684 25.9751 28.8307 25.605M25.9141 15.7423C27.1357 16.2368 27.9974 17.4344 27.9974 18.8333C27.9974 20.2322 27.1357 21.4299 25.9141 21.9244M27.1641 30.5C27.1641 28.9469 27.1641 28.1703 26.9103 27.5577C26.572 26.741 25.9231 26.092 25.1063 25.7537C24.4938 25.5 23.7172 25.5 22.1641 25.5H19.6641C18.1109 25.5 17.3344 25.5 16.7218 25.7537C15.905 26.092 15.2561 26.741 14.9178 27.5577C14.6641 28.1703 14.6641 28.9469 14.6641 30.5M24.2474 18.8333C24.2474 20.6743 22.755 22.1667 20.9141 22.1667C19.0731 22.1667 17.5807 20.6743 17.5807 18.8333C17.5807 16.9924 19.0731 15.5 20.9141 15.5C22.755 15.5 24.2474 16.9924 24.2474 18.8333Z",
    stroke: "#0860C4",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAssignIndividuallyLepAtm);
export default __webpack_public_path__ + "static/media/assign-individually-lep-atm.a7e306e2ef18a859800ba0df4288081f.svg";
export { ForwardRef as ReactComponent };